// Shared MET-based kcal estimator — used by both the JournalSection's
// per-session Completed Activity card and Tracker.jsx's TodayHero burn
// summary so both surfaces agree on the number. Fallback for TP feeds
// that don't ship `caloriesBurned` (very common on free-tier accounts).
//
// MET values follow the 2011 Compendium of Physical Activities for
// generic effort levels — not perfect but close enough for daily
// fuelling decisions.
export const SPORT_MET = { run: 10, walk: 4, ride: 7.5, bike: 7.5, swim: 7, hike: 6, other: 6, strength: 5 };

// A TrainingPeaks session only counts as genuinely completed when the feed
// carries at least one real metric alongside its "completed" flag. Some TP
// exports tick a workout off with no data at all, which used to turn the
// session card green with an empty stats strip.
export const tpHasActuals = (t) => !!(t && (t.durationMin || t.distanceMi || t.paceMinPerMi ||
  t.caloriesBurned || t.avgHr || t.tss));
export const tpSessionDone = (t) => !!(t && t.completed && tpHasActuals(t));

export function estimateKcal({ sport, durationMin, weightKg }) {  if (!durationMin || durationMin <= 0) return null;
  const met = SPORT_MET[sport] || SPORT_MET.other;
  // 70kg fallback keeps the estimate reasonable when we don't know the
  // athlete's weight yet (fresh accounts pre-Tracker weigh-in).
  const w = weightKg && weightKg > 30 ? weightKg : 70;
  return Math.round(met * w * (durationMin / 60));
}
